import {Component, Input, OnInit} from '@angular/core';
import { Social, SocialCapacity } from 'src/app/core';

@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.less'],
})
export class SocialComponent implements OnInit {
  @Input() socialCapacities: SocialCapacity[];
  @Input() showCapacities = false;
  socialEnum = Social;
  GLOBAL_SOCIAL_PREFIX = 'SOCIAL.TOOLTIPS';

  ngOnInit() {
    this.filterGroupedSocialIcons();
  }

  getStrPath(path: string) {
    return `${this.GLOBAL_SOCIAL_PREFIX}.${path.toUpperCase()}`;
  }

  removeSocialFromArray(index: number, checked: boolean): boolean {
    if (checked) {
      this.socialCapacities.splice(index, 1);
    }
    return true;
  }

  filterGroupedSocialIcons() {
    let checked = false;
    if (typeof this.socialCapacities !== 'undefined') {
      this.socialCapacities.forEach(
        (socialCapacity: SocialCapacity, index: number) => {
          switch (socialCapacity.social) {
            case Social.FACEBOOK:
              checked = this.removeSocialFromArray(index, checked);
              break;
            case Social.TWITTER:
              checked = this.removeSocialFromArray(index, checked);
              break;
            default:
              break;
          }
        }
      );
    }
  }
}
